import { Plugin, PluginKey } from "prosemirror-state";
import { Extension } from "@tiptap/core";

export const YoutubeLinkHandler = Extension.create({
    name: "youtubeLinkHandler",

    addProseMirrorPlugins() {
        return [
            new Plugin({
                key: new PluginKey("youtubeLinkHandler"),
                props: {
                    handlePaste: (view, event, slice) => {
                        const text = event.clipboardData?.getData("text/plain");

                        if (text && isYouTubeUrl(text)) {
                            fetchYouTubeTitle(text).then((title) => {
                                const { state, dispatch } = view;
                                const { from, to } = state.selection;

                                const linkNode = state.schema.text(title, [
                                    state.schema.marks.link.create({
                                        href: text,
                                    }),
                                ]);

                                dispatch(
                                    state.tr.replaceRangeWith(
                                        from,
                                        to,
                                        linkNode
                                    )
                                );
                            });

                            return true; // block default paste
                        }

                        return false;
                    },
                },
            }),
        ];
    },
});

function isYouTubeUrl(url: string) {
    return /^https?:\/\/(www\.)?(youtube\.com|youtu\.be)\//.test(url);
}

async function fetchYouTubeTitle(url: string): Promise<string> {
    try {
        const res = await fetch(
            `https://www.youtube.com/oembed?url=${encodeURIComponent(
                url
            )}&format=json`
        );
        const data = await res.json();
        return data.title;
    } catch (e) {
        return "YouTube Video";
    }
}
